import { useCallback, useEffect, useState } from 'react';
import { request } from '../../services/api';

export default function ContactsPage({ token }) {
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [message, setMessage] = useState('');

  const load = useCallback(() => {
    request('/api/contracts/contacts', { token }).then((response) => setContacts(response.data));
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const deleteContact = async (id) => {
    if (!window.confirm('Delete this contact permanently?')) return;
    await request(`/api/contracts/contacts/${id}`, { token, method: 'DELETE' });
    setMessage('Contact deleted.');
    load();
    setTimeout(() => setMessage(''), 4000);
  };

  return (
    <section className="panel">
      <div className="panel-header-actions">
        <div>
          <h2>Contract Contacts</h2>
          <p className="panel-subtitle">Directory of clients and employees who have e-signed agreements.</p>
        </div>
      </div>

      {message && <div className="alert success">{message}</div>}

      {!contacts.length ? (
        <div className="empty">No contact records found. They will appear here once contracts are e-signed.</div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email Address</th>
                <th>Phone Number</th>
                <th>Signed Agreements</th>
                <th>Latest Agreement</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact.id || contact.uuid}>
                  <td>
                    <strong>{contact.full_name || '-'}</strong>
                  </td>
                  <td>{contact.email || '-'}</td>
                  <td>{contact.phone || '-'}</td>
                  <td>
                    <span className="badge signed">{contact.total_signed_contracts || 0} signed</span>
                  </td>
                  <td>{contact.latest_contract_title || '-'}</td>
                  <td className="actions">
                    <button type="button" onClick={() => setSelectedContact(contact)}>
                      👁️ View Details
                    </button>
                    <button type="button" className="danger-button" onClick={() => deleteContact(contact.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Profile Details Modal Drawer */}
      {selectedContact && (
        <div className="modal-backdrop" onClick={() => setSelectedContact(null)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🔍 Signer Verified Profile</h3>
              <button type="button" className="close-btn" onClick={() => setSelectedContact(null)}>
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="profile-details-grid">
                <div className="detail-item">
                  <strong>Full Legal Name</strong>
                  <span>{selectedContact.full_name || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Email Address</strong>
                  <span>{selectedContact.email || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Phone Number</strong>
                  <span>{selectedContact.phone || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Physical Address</strong>
                  <span>{selectedContact.address || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>National ID / NIDA</strong>
                  <span>{selectedContact.national_id || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Emergency Contact</strong>
                  <span>{selectedContact.emergency_contact || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Total Signed Agreements</strong>
                  <span>{selectedContact.total_signed_contracts || 0}</span>
                </div>
                <div className="detail-item">
                  <strong>Latest Signed Contract</strong>
                  <span>{selectedContact.latest_contract_title || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <strong>Latest Verification Timestamp</strong>
                  <span>{selectedContact.updated_at ? new Date(selectedContact.updated_at).toLocaleString() : 'N/A'}</span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="ghost" onClick={() => setSelectedContact(null)}>
                Close Profile
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
